export default {
      id: "location-usage",
      viewBox: "0 0 18 20",
      url: "/" + "sprite.svg#location",
      toString: function () {
        return this.url;
      }
    }